module.exports = __webpack_public_path__ + "img/icon-Social8.90d811ad.png";